<div style="height: 40px">
  <div class="work-shifts__weeks-header-wrapper" #weeksHeaderWrapper style="height: 40px">
    <div class="work-shifts__weeks-header" #weeksHeader [class.weeks-header--fixed]="fixedHeader">
      <ng-container *ngIf="calendar && calendar.calendar && calendar.calendar.length">
        <div class="weeks-header__title">ФИО</div>
        <div class="weeks-header__date-block" [class.weeks-header__date-block--indent]="isGRS">
          <div class="date-block__date" *ngFor="let date of calendar.calendar; trackBy: $safeNavigationMigration(data?.day)" [class.bg-gray-pale]="date.is_today">
            <div class="date__number">{{ date.day }}</div>
            <div class="date__name">{{ date.weekday_str }}</div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="calendar && calendar.calendar && !calendar.calendar.length">
        <div class="text-italic color-gray-dark">Нет данных для отображения</div>
      </ng-container>
    </div>
  </div>
</div>

<div *ngFor="let user of users" class="work-shifts__weeks" id="{{ user.u_id }}">
  <div class="weeks__title">
    <div [hidden]="templateFilter.isActiveTemplateFilter">
      <button class="ctrl name-ellipsis" id="{{ 'appAddSelectedUser' + user.u_id }}" [ngClass]="{ 'color-red-dark': user.isSomeCellInvalid }">
        {{ user?.employee?.full_name }}
      </button>
    </div>
    <div [hidden]="!templateFilter.isActiveTemplateFilter">
      <button
        class="ctrl name-ellipsis"
        id="{{ 'appAddSelectedUser2' + user.u_id }}"
        *ngIf="!user.isSelected"
        [ngClass]="{ 'color-red-dark': user.isSomeCellInvalid }"
        (click)="onAddSelectedUser(user)"
        [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
      >
        <span [hidden]="templateFilter.isActiveTemplateFilterPreviewMode">
          <app-icon [glyph]="'plus'" [size]="'14'" [color]="'blue'"></app-icon>
        </span>
        <span [hidden]="!templateFilter.isActiveTemplateFilterPreviewMode">
          <app-icon [glyph]="'plus'" [size]="'14'" [color]="'gray'"></app-icon>
        </span>
        <span class="link link--dotted-blue-dark ml-4 name-ellipsis__link" [class.link--disabled]="templateFilter.isActiveTemplateFilterPreviewMode">
          {{ user?.employee?.full_name }}
        </span>
      </button>
      <button
        class="ctrl name-ellipsis"
        id="{{ 'appAddSelectedUser3' + user.u_id }}"
        *ngIf="user.isSelected"
        [ngClass]="{ 'color-red-dark': user.isSomeCellInvalid }"
        (click)="onRemoveSelectedUser(user)"
        [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
      >
        <span [hidden]="templateFilter.isActiveTemplateFilterPreviewMode">
          <app-icon [glyph]="'minus'" [size]="'14'" [color]="'blue'"></app-icon>
        </span>
        <span [hidden]="!templateFilter.isActiveTemplateFilterPreviewMode">
          <app-icon [glyph]="'minus'" [size]="'14'" [color]="'gray'"></app-icon>
        </span>
        <span class="link link--dotted-blue-dark ml-4 name-ellipsis__link" [class.link--disabled]="templateFilter.isActiveTemplateFilterPreviewMode">
          {{ user.employee.full_name }}
        </span>
      </button>
    </div>
    <div class="grid grid--gap-0">
      <div class="grid__box">
        <app-work-shift-user-popover [user]="user" [templateFilter]="templateFilter"></app-work-shift-user-popover>
      </div>
      <div class="grid__box grid__box--size-min" style="height: 12px">
        <app-work-shift-role-popover [userGroups]="user.user_groups"></app-work-shift-role-popover>
      </div>
    </div>
    <div class="title__worker-progress">
      <div class="grid grid--va-middle">
        <div class="grid__box">
          <app-work-shifts-progress [calendar]="calendar" [user]="user"></app-work-shifts-progress>
        </div>
        <div class="grid__box grid__box--size-min grid__box--pull-right">
          <span class="color-gray-dark text-italic">
            <span
              [ngClass]="{
                'color-red-dark': (user.milis_worked_total | workShiftHoursOnly) > calendar.working_hours_total,
                'color-gray-dark': (user.milis_worked_total | workShiftHoursOnly) < calendar.working_hours_total
              }"
            >
              {{ user.milis_worked_total | workShiftHoursOnly }}
            </span>
            <span class="work-shift__working-hours">{{ calendar.working_hours_total }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="weeks__date-block" [class.weeks__date-block--selected]="user.isSelected">
    <div class="period-block__cell" *ngIf="isGRS">
      <div class="period-block__text">начало</div>
      <div class="period-block__text">конец</div>
      <div class="period-block__text">число часов</div>
    </div>
    <div
      class="date-block__date"
      *ngFor="let cell of user.working_shift | workShiftsDays: isGRS as formattedWShifts; let index = index"
      [class.date-block__date--ivalid]="cell.isCellInvalid"
    >
      <work-shift-cell-popover
        [filter]="filter"
        [templateFilter]="templateFilter"
        [templateFilterData]="templateFilterData"
        [user]="user"
        [cell]="cell"
        [previousCell]="user.working_shift[index]"
        [calendar]="calendar"
        [index]="index + 1"
        [endIndex]="formattedWShifts.length"
        [isActiveTemplateFilterPreviewMode]="isActiveTemplateFilterPreviewMode"
      ></work-shift-cell-popover>
    </div>
  </div>
</div>
<div *ngIf="filter && filter.fullNameCopy && (!users || (users && !users.length))" class="padding-32 ta-center">
  <span class="text-italic color-gray">По критериям “{{ filter && filter.fullNameCopy }}” ничего не найдено.</span>
</div>
